import { Component, input } from '@angular/core';
import { IUserPaymentMethod } from '@webapp/users/interfaces/users.interface';

@Component({
	selector: 'app-payment-card-item',
	imports: [],
	standalone: true,
	templateUrl: './payment-card-item.component.html',
	styleUrl: './payment-card-item.component.scss',
})
export class PaymentCardItemComponent {
	paymentMethod = input<IUserPaymentMethod>();
}
